import React, { useEffect, useReducer, useRef, useState } from "react";
import styled, { keyframes } from "styled-components";
import { lightThemeColors } from "../../assets/styles/colors";
import { ReactComponent as CloseModalIcon } from "../../assets/icons/generic/CloseModalIcon.svg";
import SocialMediaNewLink from "./SocialMediaNewLink";
import PrimaryButton from "../Generic/PrimaryButton";

import DataNewLink from "./DataNewLink";
import DetailsNewLink from "./DetailsNewLink";
import UTMSParamsLink from "./UTMSParamsLink";

import SocialMediaButtonsGroup from "../configurationComponents/SocialMediaButtonsGroup";
import FacebookCardPreview from "../configurationComponents/FacebookCardPreview";
import {
  CREATE_LINK,
  FACEBOOK,
  FILE,
  GOOGLE,
  GROVS,
  LINK,
  LINKEDIN,
  META,
  QUICK_LINK,
  SELECT_LINK,
  TIKTOK,
  X,
} from "../../constants/OptionsConstants";
import SecondaryButton from "../Generic/SecondaryButton";
import { ReactComponent as CopyIcon } from "../../assets/icons/generic/CopyIcon.svg";
import GeneratedLink from "./GeneratedLink";
import { useLinkContext } from "../../context/useLinkContext";
import { useInstanceContext } from "../../context/useInstanceContext";
import {
  showErrorNotification,
  showGenericError,
} from "../../helper/Notifications";
import LableWithArrow from "../configurationComponents/LableWithArrow";
import XCardPreview from "../configurationComponents/XCardPreview";
import LinkedInCardPreview from "../configurationComponents/LinkedInCardPreview";
import { copyToClipboard } from "../../helper/copy";
import InputFieldWithValidation from "../Generic/InputFieldWithValidation";
import { isURL } from "validator";
import { motion } from "framer-motion";
import LinkTypeElement from "./LinkTypeElement";
import { ReactComponent as Grovs } from "../../assets/icons/linkTypeAdsIcons/Grovs.svg";
import { ReactComponent as GoogleAdIcon } from "../../assets/icons/linkTypeAdsIcons/Google.svg";
import { ReactComponent as MetaAdIcon } from "../../assets/icons/linkTypeAdsIcons/MetaPlatforms.svg";
import { ReactComponent as LinkedinAdIcon } from "../../assets/icons/linkTypeAdsIcons/LinkedIn.svg";
import { ReactComponent as TikTokAdIcon } from "../../assets/icons/linkTypeAdsIcons/TikTok.svg";
import GeneratedQuickLinkPreview from "./GeneratedQuickLinkPreview";
import RedirectsLink from "./RedirectsLink";

const CreateNewLinkModal = ({ setIsModalOpen, campaignID }) => {
  const { createLink, getRandomPath, isPathAvailable, shouldRefreshLinksRef } =
    useLinkContext();
  const { selectedProject } = useInstanceContext();

  const [domain, setDomain] = useState("https://" + selectedProject.domain);

  const [linkName, setLinkName] = useState("");
  const [path, setPath] = useState("");

  const [socialMediaTitle, setSocialMediaTitle] = useState("");
  const [socialMediaSubTitle, setSocialMediaSubTitle] = useState("");
  const [imageFile, setImageFile] = useState();
  const [imageLink, setImageLink] = useState("");
  const [imageType, setImageType] = useState(FILE);
  const [tagInput, setTagInput] = useState("");
  const [imagePreview, setImagePreview] = useState();
  const [createdLink, setCreatedLink] = useState(null);
  const [pathAvailable, setPathAvailable] = useState(true);
  const [replaceImage, handleSetReplaceImage] = useState(false);
  const [selectedLinkType, setSelectedLinkType] = useState(QUICK_LINK);

  const [utmCampaign, setUtmCampaign] = useState(null);
  const [utmMedium, setUtmMedium] = useState(null);
  const [utmSource, setUtmSource] = useState(null);

  const [tagsList, setTagsList] = useState([]);

  const [keyValuePair, setKeyValuePair] = useState([]);

  const [isLinkGenerated, setIsLinkGenerated] = useState(false);
  const [socialMediaCardType, setSocialMediaCardType] = useState(FACEBOOK);
  const [level, setLevel] = useState(SELECT_LINK);

  const [androidRedirectURL, setAndroidRedirectURL] = useState(null);
  const [iOSRedirectURL, setiOSRedirectURL] = useState(null);
  const [desktopRedirectURL, setDesktopRedirectURL] = useState(null);
  const [showPreviewIos, setShowPreviewIos] = useState(null);
  const [showPreviewAndroid, setShowPreviewAndroid] = useState(null);

  const ref = useRef();

  const inputContainerStyle = {
    background: "none",
    border: "none",
    padding: 0,
  };

  const inputCustomStyle = {
    background: "none",
    overflow: "hidden",
    whiteSpace: "wrap",
    textOverflow: "ellipsis",
    color: lightThemeColors.darkColor,
    fontSize: "18px",
    fontWeight: 500,
    lineHeight: "27px",
  };
  const linkTypeElements = [
    {
      id: GOOGLE,
      title: "Google Ads",
      subtitle: "Optimized for search and display campaigns.",
      value: GOOGLE,
      icon: <GoogleAdIcon />,
    },
    {
      id: META,
      title: "Meta Ads",
      subtitle: "Tailored for Facebook and Instagram ad campaigns.",
      value: META,
      icon: <MetaAdIcon />,
    },
    {
      id: LINKEDIN,
      title: "LinkedIn Ads",
      subtitle: "Perfect for professional and B2B marketing.",
      value: LINKEDIN,
      icon: <LinkedinAdIcon />,
    },
    {
      id: TIKTOK,
      title: "TikTok Ads",
      subtitle: "Built for engaging, short-form video campaigns.",
      value: TIKTOK,
      icon: <TikTokAdIcon />,
    },
  ];

  const handleSetImageType = (imageType) => {
    if (imageType === FILE) {
      setImageType(imageType);
      setImageLink("");
    }

    if (imageType === LINK) {
      setImageType(imageType);
      setImageFile(null);
    }
  };

  const handleSetImage = (e) => {
    setImageFile(e.currentTarget.files[0]);
    let preview = createPreview(e.currentTarget.files[0]);
    setImagePreview(preview);
  };

  const hasDuplicateKeys = (arr) => {
    const seenKeys = new Set();
    return arr.some((item) => {
      if (item.key === "") return false; // skip empty keys
      if (seenKeys.has(item.key)) {
        return true;
      }
      seenKeys.add(item.key);
      return false;
    });
  };

  const createPreview = (imageInput) => {
    if (!imageInput) {
      return;
    }
    let preview = URL.createObjectURL(imageInput);
    return preview;
  };

  const handleCreateLinks = () => {
    let formData = new FormData();
    formData.append("name", linkName);
    formData.append("path", path);
    formData.append("ads_platform", selectedLinkType);

    if (socialMediaTitle != "") {
      formData.append("title", socialMediaTitle);
    }

    if (socialMediaSubTitle != "") {
      formData.append("subtitle", socialMediaSubTitle);
    }

    if (imageType === FILE) {
      if (imageFile) {
        formData.append("image", imageFile);
      }
    }

    if (imageType === LINK) {
      if (imageLink) {
        formData.append("image_url", imageLink);
      }
    }

    if (tagsList.length > 0) {
      formData.append("tags", JSON.stringify(tagsList));
    }

    if (iOSRedirectURL) {
      formData.append("ios_custom_redirect", JSON.stringify(iOSRedirectURL));
    }

    if (androidRedirectURL) {
      formData.append(
        "android_custom_redirect",
        JSON.stringify(androidRedirectURL)
      );
    }

    if (showPreviewIos != null) {
      formData.append("show_preview_ios", showPreviewIos);
    }

    if (showPreviewAndroid != null) {
      formData.append("show_preview_android", showPreviewAndroid);
    }

    if (desktopRedirectURL) {
      formData.append(
        "desktop_custom_redirect",
        JSON.stringify(desktopRedirectURL)
      );
    }

    if (keyValuePair.length > 0) {
      let dictionar = {};

      keyValuePair.forEach((item) => {
        if (item.value != "" && item.key != "") {
          Object.assign(dictionar, { [item.key]: item.value });
        }
      });

      if (Object.keys(dictionar).length > 0) {
        formData.append("data", JSON.stringify(dictionar));
      }
    }

    if (campaignID != null) {
      formData.append("campaign_id", campaignID);
    }

    if (utmCampaign && utmCampaign.length > 0) {
      formData.append("tracking_campaign", utmCampaign);
    }

    if (utmMedium && utmMedium.length > 0) {
      formData.append("tracking_medium", utmMedium);
    }

    if (utmSource && utmSource.length > 0) {
      formData.append("tracking_source", utmSource);
    }

    if (hasDuplicateKeys(keyValuePair)) {
      showErrorNotification("You have duplicate keys");
    } else {
      createLink(
        selectedProject.id,
        formData,
        (response) => {
          const link = response.data.link;
          setCreatedLink(link);
          setIsLinkGenerated(true);
          shouldRefreshLinksRef.current = true;
        },
        () => {
          showGenericError();
        }
      );
    }
  };

  const disabledCreateButton = () => {
    let validImageLink = true;
    if (imageLink) {
      validImageLink = isURL(imageLink);
    }

    let redirectsValid = true;
    if (androidRedirectURL) {
      redirectsValid = redirectsValid && isURL(androidRedirectURL?.url);
    }

    if (iOSRedirectURL) {
      redirectsValid = redirectsValid && isURL(iOSRedirectURL?.url);
    }

    if (desktopRedirectURL) {
      redirectsValid = redirectsValid && isURL(desktopRedirectURL?.url);
    }

    if (
      linkName.length < 3 ||
      path.length < 3 ||
      !validImageLink ||
      !redirectsValid ||
      !pathAvailable
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handleSelectLinkType = (value) => {
    setSelectedLinkType(value);
  };

  const handleContinueBtn = () => {
    setLevel(CREATE_LINK);
  };

  const displaySocialMediaCardForGeneratedLink = () => {
    if (!createdLink) {
      return;
    }
    var displayCard = <></>;
    switch (socialMediaCardType) {
      case FACEBOOK:
        displayCard = (
          <FacebookCardPreview
            img={createdLink?.image}
            title={createdLink?.title}
            domain={createdLink?.access_path}
            subtitle={createdLink?.subtitle}
          />
        );
        break;
      case X:
        displayCard = (
          <XCardPreview
            img={createdLink?.image}
            title={createdLink?.title}
            domain={createdLink?.access_path}
            subtitle={createdLink?.subtitle}
          />
        );

        break;
      case LINKEDIN:
        displayCard = (
          <LinkedInCardPreview
            img={createdLink?.image}
            title={createdLink?.title}
            domain={createdLink?.access_path}
            subtitle={createdLink?.subtitle}
          />
        );
        break;

      default:
        break;
    }
    return displayCard;
  };

  const createLinkContent = (
    <>
      <ConfigList>
        <PathTitle>
          <h2>URL</h2>
        </PathTitle>
        <LinkPathWrapper>
          <LinkWrapper>
            <p>{domain}</p>
          </LinkWrapper>
          <PathWrapper>
            <InputFieldWithValidation
              inputCustomStyle={inputCustomStyle}
              inputContainerStyle={inputContainerStyle}
              style={{ margin: 0 }}
              inputValue={path}
              valid={pathAvailable}
              handleInputChange={(e) => setPath(e.currentTarget.value)}
            />
          </PathWrapper>
        </LinkPathWrapper>
        <DetailsNewLink
          linkName={linkName}
          setLinkName={setLinkName}
          tagInput={tagInput}
          setTagInput={setTagInput}
          tagsList={tagsList}
          setTagsList={setTagsList}
        />
        <SocialMediaNewLink
          socialMediaTitle={socialMediaTitle}
          setSocialMediaTitle={setSocialMediaTitle}
          socialMediaSubTitle={socialMediaSubTitle}
          setSocialMediaSubTitle={setSocialMediaSubTitle}
          handleSetImage={handleSetImage}
          imageLink={imageLink}
          imageFile={imageFile}
          setImageLink={setImageLink}
          imageType={imageType}
          setImageType={handleSetImageType}
          tagInput={tagInput}
          setTagInput={setTagInput}
          tagsList={tagsList}
          setTagsList={setTagsList}
          domain={domain}
          path={path}
          imagePreview={imagePreview}
          replaceImage={replaceImage}
          handleSetReplaceImage={handleSetReplaceImage}
          setImageFile={setImageFile}
        />
        <DataNewLink
          keyValuePair={keyValuePair}
          setKeyValuePair={setKeyValuePair}
        />
        <RedirectsLink
          androidRedirectURL={androidRedirectURL}
          setAndroidRedirectURL={setAndroidRedirectURL}
          iOSRedirectURL={iOSRedirectURL}
          setiOSRedirectURL={setiOSRedirectURL}
          desktopRedirectURL={desktopRedirectURL}
          setDesktopRedirectURL={setDesktopRedirectURL}
          noLabel={false}
          showPreviewAndroid={showPreviewAndroid}
          setShowPreviewAndroid={setShowPreviewAndroid}
          showPreviewIOS={showPreviewIos}
          setShowPreviewIOS={setShowPreviewIos}
        />
        <UTMSParamsLink
          utmCampaign={utmCampaign}
          setUtmCampaign={setUtmCampaign}
          utmMedium={utmMedium}
          setUtmMedium={setUtmMedium}
          utmSource={utmSource}
          setUtmSource={setUtmSource}
        />
        <PrimaryButton
          styled={{ width: "100%", marginTop: "auto", padding: "12px" }}
          text={"Create New Link"}
          onClick={() => handleCreateLinks()}
          disabled={disabledCreateButton()}
        />
      </ConfigList>
    </>
  );

  const newLinkGeneratedContent = (
    <GeneratedQuickLinkPreview
      createdLink={createdLink}
      socialMediaCardType={socialMediaCardType}
      setSocialMediaCardType={setSocialMediaCardType}
      displaySocialMediaCardForGeneratedLink={
        displaySocialMediaCardForGeneratedLink
      }
    />
  );

  const selectLinkType = (
    <ConfigList>
      <HeadWrapper>
        <PathTitle>
          <h2>General Purpose Link</h2>
        </PathTitle>
        <InfoText>
          Here is the link that has been newly generated for you and how your
          new link will appear when shared across various platforms.
        </InfoText>
      </HeadWrapper>
      <LinkTypeElement
        title={"Quick Link"}
        subtitle={
          "Ideal for social media, user sharing, or general-purpose dynamic links."
        }
        value={QUICK_LINK}
        handleClick={() => handleSelectLinkType(QUICK_LINK)}
        selected={selectedLinkType === QUICK_LINK}
        icon={<Grovs />}
      />
      <HeadWrapper>
        <PathTitle>
          <h2>Link for Ad Platforms</h2>
        </PathTitle>
        <InfoText>
          These links are designed to integrate seamlessly with ad campaigns,
          offering precise tracking and optimization to drive measurable
          results.
        </InfoText>
      </HeadWrapper>
      <HeadWrapper>
        {linkTypeElements.map((element, index) => (
          <LinkTypeElement
            key={element.value}
            title={element.title}
            subtitle={element.subtitle}
            value={element.value}
            handleClick={() => handleSelectLinkType(element.value)}
            selected={selectedLinkType === element.value}
            icon={element.icon}
          />
        ))}
      </HeadWrapper>
      <PrimaryButton
        styled={{ width: "100%", marginTop: "20px", padding: "12px" }}
        text={"Continue"}
        onClick={() => handleContinueBtn()}
      />
    </ConfigList>
  );

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (setIsModalOpen && ref.current && !ref.current.contains(e.target)) {
        setIsModalOpen(false);
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [setIsModalOpen]);

  useEffect(() => {
    const close = (e) => {
      if (e.keyCode === 27) {
        setIsModalOpen(false);
      }
    };
    window.addEventListener("keydown", close);
    return () => window.removeEventListener("keydown", close);
  }, []);

  useEffect(() => {
    getRandomPath(
      selectedProject.id,
      (response) => {
        setPath(response.data.valid_path);
      },
      () => {
        showGenericError();
      }
    );
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      isPathAvailable(
        selectedProject.id,
        path,
        (response) => {
          const available = response.data.available;
          setPathAvailable(available);
          if (!available) {
            showErrorNotification("Path is not available");
          }
        },
        (error) => {
          setPathAvailable(false);
          console.log(error);
        }
      );
    }, 250);
    return () => {
      clearTimeout(timeout);
    };
  }, [path]);

  useEffect(() => {
    if (imageType === LINK) {
      setImagePreview(imageLink);
    } else {
      let preview = createPreview(imageFile);
      setImagePreview(preview);
    }
  }, [imageType, imageLink, imageFile]);

  return (
    <FullscreenContainer id="new-link-modal">
      <InviteModal
        ref={ref}
        as={motion.div}
        initial={{ translateX: "100%" }}
        animate={{ translateX: "0" }}
        exit={{ translateX: "100%" }}
        transition={{ duration: 0.4 }}
      >
        <Line style={{ padding: "0 40px" }}>
          <HeadWrapper>
            {level === SELECT_LINK && (
              <h1>
                {campaignID
                  ? "Add a new link for your campaign"
                  : "Select link type"}
              </h1>
            )}
            {level === CREATE_LINK &&
              (isLinkGenerated ? (
                <h1>Generated Link</h1>
              ) : (
                <h1>Create New Link</h1>
              ))}
            {/* {isLinkGenerated && (
              <p>
                Here is the link that has been newly generated for you and how
                your new link will appear when shared across various platforms.
              </p>
            )} */}
          </HeadWrapper>
          <CloneBtn
            onClick={() => setIsModalOpen(false)}
            style={{ marginLeft: "auto" }}
          >
            <CloseModalIcon />
          </CloneBtn>
        </Line>
        {level === SELECT_LINK && selectLinkType}
        {level === CREATE_LINK &&
          (isLinkGenerated ? newLinkGeneratedContent : createLinkContent)}
      </InviteModal>
    </FullscreenContainer>
  );
};

export default CreateNewLinkModal;
const FullscreenContainer = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.1);
  z-index: 5;
`;
const expandAnimation = keyframes`
0% { transform:translateX(100%)}

100% {
   transform: translateX(0)
}

`;

const InviteModal = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background: ${lightThemeColors.background};
  max-width: 750px;
  width: 100%;
  height: 100%;
  margin-left: auto;
  padding: 40px 0;
  // animation: ${expandAnimation} 400ms linear;
  gap: 40px;
  overflow: auto;
  .control {
    border-radius: 5px;
  }
`;

const CloneBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  border: none;
  background: none;
  cursor: pointer;
`;
const HeadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  h1 {
    color: ${lightThemeColors.darkColorFaded};
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
  }
  p {
    color: ${lightThemeColors.darkColorFaded30};
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
  }
`;
const Line = styled.div`
  display: flex;
  gap: 30px;
  align-items: center;
`;
const ConfigList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow: auto;
  position: relative;
  height: 100%;
  padding: 0 40px 30px 40px;
`;
const LinkPathWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 60px;
  border-radius: 5px;
  overflow: hidden;
`;

const LinkWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background: ${lightThemeColors.sidebar.linkBg};
  width: 50%;
  min-height: 60px;
  p {
    overflow: hidden;
    white-space: wrap;
    text-overflow: ellipsis;
    color: ${lightThemeColors.primaryColor};
    font-size: 18px;
    font-weight: 500;
    line-height: 27px;
  }
`;
const PathWrapper = styled(LinkWrapper)`
  background: ${lightThemeColors.menuBackground};
  p {
    color: ${lightThemeColors.darkColor};
  }
`;
const Separator = styled.div`
  display: flex;
  height: 1px;
  min-height: 1px;
  width: 100%;
  background: ${lightThemeColors.darkColor};
  opacity: 0.1;
`;
const PathTitle = styled.div`
  h2 {
    font-size: 16px;
    font-weight: 600;
    color: ${lightThemeColors.darkColorFaded};
  }
`;

const InfoText = styled.p`
  color: ${lightThemeColors.darkColorFaded30};
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
`;
